import { observer } from "mobx-react";
import { TMessage } from "../i18n/tt";
import { AppBarData } from "../appBar/appBarDomain";
import { isMobileView } from "../utils/screen";
import { Box, Grid } from "../components-v2/Box";
import { Logo } from "../components-v2/Logo";
import { UserMenu } from "../components-v2/AppBar";
import { useTranslation } from "../stores/RootStoreContext";
import { Icon } from "../components-v2/Icon";

export type TitleTextProps = {
  title: TMessage;
  subtitle?: TMessage;
};

export const TitleText = observer(({ title, subtitle }: TitleTextProps) => {
  const { t } = useTranslation();
  return (
    <div className="tw-truncate">
      <div className="semibold tw-truncate">{t(title)}</div>
      {subtitle && <div className={"subtle tw-truncate"}>{t(subtitle)}</div>}
    </div>
  );
});

export type LandingPageHeaderProps = {
  logoLinkUrl: string;
  title?: TMessage;
  companyContext?: TitleTextProps;
  userContext?: TitleTextProps;
  userMenu?: AppBarData;
};

export const LandingPageHeader = observer(
  ({ userMenu, companyContext, title, userContext, logoLinkUrl }: LandingPageHeaderProps) => {
    const { t } = useTranslation();

    return isMobileView() ? (
      <Box justifyContent={"space-between"} alignItems="center" borderBottom bg padding>
        <Box alignItems={"center"} gap={"md"} className="tw-truncate">
          <Logo linkUrl={logoLinkUrl} />
          {companyContext && <TitleText {...companyContext} />}
        </Box>
        {userMenu && <UserMenu {...userMenu} />}
      </Box>
    ) : (
      <Grid cols={3} borderBottom bg padding gap={"md"}>
        <Box alignItems={"center"} gap={"md"} className="tw-truncate">
          <Logo linkUrl={logoLinkUrl} />
          {companyContext && <TitleText {...companyContext} />}
        </Box>
        <Box alignItems="center" className="tw-truncate" justifyContent="center">
          {title && (
            <Box
              alignItems="center"
              className="tw-truncate bg-alt2-dimmed"
              rounded={"lg"}
              padding={"sm"}
              fontWeight="bold"
            >
              <Icon name={"file-text"} color={"info"} />
              <div className="tw-truncate">{t(title)}</div>
            </Box>
          )}
        </Box>
        <Box
          alignItems={"center"}
          gap={"md"}
          className="tw-truncate"
          textAlign="right"
          justifyContent="end"
        >
          {userContext && <TitleText {...userContext} />}
          {userMenu && <UserMenu {...userMenu} />}
        </Box>
      </Grid>
    );
  },
);
